import styled from 'styled-components'

export const StyledList = styled.div`
  position: relative;
`
